"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sql = exports.queryIdOf = exports.escapeValues = exports.compile = void 0;
const sha1_1 = __importDefault(require("sha1"));
const doubleNewlinesRegex = /[\n\r]+^\s*[\r\n]+/gm;
const compile = (strings, variableAccesses, variables, transformer) => {
    let out = [strings[0]];
    variableAccesses.forEach((variableName, i) => out.push(transformer(variableName, variables, i), strings[i + 1]));
    return out
        .join('')
        .trim()
        .replace(doubleNewlinesRegex, '\n');
};
exports.compile = compile;
const escapeValues = (key, variables) => {
    let value = variables[key[0]];
    switch (key[1]) {
        case 'string':
            return `'${value}'`;
        case 'int':
            return value;
        case 'array':
            return `'{${value.map(value1 => `"${value1}"`).join(', ')}}'`;
        case 'intarr':
            return `'{${value.map(value1 => `${Math.round(value1)}`).join(', ')}}'`;
        case 'variableName':
            return value;
    }
};
exports.escapeValues = escapeValues;
const queryIdOf = (prepared) => sha1_1.default(prepared).substr(20);
exports.queryIdOf = queryIdOf;
function sql(strings, ...variableAccesses) {
    return (variables) => {
        const prepared = exports.compile(strings, variableAccesses, variables, () => '?');
        const res = {
            id: exports.queryIdOf(prepared),
            compiled: exports.compile(strings, variableAccesses, variables, exports.escapeValues),
            prepared: prepared,
            params: variableAccesses.map(namedParam => variables[namedParam[0]]),
            experimental: exports.compile(strings, variableAccesses, variables, (key, _2) => `${key[1] === 'string'
                ? '%L'
                : key[1] === 'array'
                    ? '%L'
                    : key[1] === 'int'
                        ? '%L'
                        : key[1] === 'intarr'
                            ? '%L'
                            : key[1] === 'variableName'
                                ? '%I'
                                : null}`),
            types: variableAccesses.map(namedParam => namedParam[1]),
        };
        return res;
    };
}
exports.sql = sql;
//# sourceMappingURL=tag.js.map